import { render, staticRenderFns } from "./PagibigContributionDetails.vue?vue&type=template&id=0e28abf6&scoped=true"
import script from "./PagibigContributionDetails.vue?vue&type=script&lang=js"
export * from "./PagibigContributionDetails.vue?vue&type=script&lang=js"
import style0 from "./PagibigContributionDetails.vue?vue&type=style&index=0&id=0e28abf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28abf6",
  null
  
)

export default component.exports